import { createStore } from 'vuex'
import auth from './modules/auth'
import user from './modules/user'
import attendance from './modules/attendance'
import leave from './modules/leave'
import chat from './modules/chat'
import notifications from './modules/notifications'
import kpi from './modules/kpi'
import employee from './modules/employee'
import language from './modules/language'
import storage from './modules/storage'
import signalR from './modules/signalR'
import document from './modules/document'
import standardData from './modules/standardData'

export default createStore({
  modules: {
    auth,
    user,
    attendance,
    leave,
    chat,
    notifications,
    kpi,
    employee,
    language,
    storage,
    signalR,
    document,
    standardData
  },
  
  state: {
    loading: false,
    error: null,
    isFlutter: false,
    flutterBridge: null
  },
  
  mutations: {
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    SET_FLUTTER(state, isFlutter) {
      state.isFlutter = isFlutter
    },
    SET_FLUTTER_BRIDGE(state, bridge) {
      state.flutterBridge = bridge
    }
  },
  
  actions: {
    initFlutterBridge({ commit }) {
      const bridge = window.flutterBridge
      if (bridge) {
        commit('SET_FLUTTER', bridge.isFlutter)
        commit('SET_FLUTTER_BRIDGE', bridge)
      }
    },
    
    showLoading({ commit }, loading = true) {
      commit('SET_LOADING', loading)
      if (window.flutterBridge) {
        window.flutterBridge.showLoading(loading)
      }
    },
    
    showError({ commit }, error) {
      commit('SET_ERROR', error)
      if (window.flutterBridge) {
        window.flutterBridge.showToast(error, 'error')
      }
    },
    
    showSuccess({ commit }, message) {
      if (window.flutterBridge) {
        window.flutterBridge.showToast(message, 'success')
      }
    },
    
    showInfo({ commit }, message) {
      if (window.flutterBridge) {
        window.flutterBridge.showToast(message, 'info')
      }
    },
    
    clearError({ commit }) {
      commit('SET_ERROR', null)
    }
  },
  
  getters: {
    isLoading: state => state.loading,
    error: state => state.error,
    isFlutter: state => state.isFlutter,
    flutterBridge: state => state.flutterBridge
  }
}) 